import React, { useState } from 'react';
import { OperationDetailListProps } from '../../types/operations';
import { Table} from '@mantine/core';
import TableMedusa from '../../components/Table';

const OperationDetailsList = ({data, colorOpt, recyclingOpt, reuseOpt}:OperationDetailListProps) =>{
         const rows = data.map(({id, position, colors, recycling_categories, reuse_categories})=>(
            <Table.Tr key={id}>
                    <Table.Td>{position}</Table.Td>
                    <Table.Td> {colors.map((color, index) => (
                               <div key={index}>{colorOpt.find(option => color === option.value)?.label}</div>))}
                    </Table.Td>
                    <Table.Td> {recycling_categories.map((type, index) => (
                               <div key={index}>{recyclingOpt.find(option => type === option.value)?.label}</div>))}
                    </Table.Td>
                    <Table.Td> {reuse_categories.map((type, index) => (
                               <div key={index}>{reuseOpt.find(option => type === option.value)?.label}</div>))}
                    </Table.Td>
            </Table.Tr>
    
        ));


    return( <TableMedusa headers={["Hopper", "Colors", "Recycling", "Reuse"]} rows={rows}></TableMedusa>)
}

export default OperationDetailsList